export default __webpack_public_path__ + "static/media/Blog_Home.541b926e.svg";